var __jsx = React.createElement;
import React, { Fragment } from 'react';
import { useTranslation } from 'next-i18next';
import { Wrapper, Sections, SectionItemList, Bills, BillsTotal, BillsTotalText, BillsTotalAmount, BillsSeparator, BillsTotalWrapper, SectionItemWrapper, Description, Value } from './styles';
import { formatMoney } from '@spa/shared/utils';
import StatusBanner from '@spa/shared/components/Unisystem/StatusBanner';
import AssignedFile from '@spa/shared/svg/assigned-file';
import { theme } from '@spa/offer/theme';
import BillItem from '../BillItem';
var ServicesExpensesMobile = function ServicesExpensesMobile(_ref) {
  var _bills$billNames$, _bills$billNames$$max, _bills$billNames$$max2;
  var servicesAndExpensesData = _ref.servicesAndExpensesData,
    landlordPoliciesData = _ref.landlordPoliciesData,
    bills = _ref.bills,
    billNames = _ref.billNames,
    canShowTotalBills = _ref.canShowTotalBills,
    totalBills = _ref.totalBills,
    globalMaximum = _ref.globalMaximum,
    isEveryBillCovered = _ref.isEveryBillCovered;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return __jsx(Wrapper, {
    id: "Services and expenses"
  }, __jsx("h2", null, t('Services and expenses')), __jsx("p", null, t('Extra services, expenses and fees to be paid directly to the Landlord')), servicesAndExpensesData.length > 0 && __jsx(Sections, null, __jsx("h3", null, t('One-time payments')), __jsx(SectionItemList, null, servicesAndExpensesData.map(function (item, index) {
    return __jsx(SectionItem, {
      key: index,
      title: item.title,
      description: item.description,
      value: item.price
    });
  }))), __jsx(Sections, null, __jsx("h3", null, t('Fixed Monthly Bills')), isEveryBillCovered && __jsx(StatusBanner, {
    message: t('Everything is covered! All bills are included in the price.'),
    icon: __jsx(AssignedFile, {
      color: theme.unisystem.statusBanner.text.green
    }),
    color: 'green',
    type: 'text'
  }), __jsx(Bills, {
    canShowBillsTotal: true
  }, isEveryBillCovered && __jsx(BillsSeparator, null), billNames.map(function (billName, index) {
    var isLastBill = index + 1 === billNames.length;
    return __jsx(Fragment, {
      key: billName
    }, __jsx(BillItem, {
      name: billName,
      bill: bills[billName],
      t: t,
      formatMoney: formatMoney
    }), !isLastBill && __jsx(BillsSeparator, null));
  }), canShowTotalBills && __jsx(BillsTotalWrapper, null, __jsx(BillsSeparator, null), __jsx(BillsTotal, null, __jsx(BillsTotalText, null, t('Total monthly bills included up to')), __jsx(BillsTotalAmount, null, formatMoney((globalMaximum === null || globalMaximum === void 0 ? void 0 : globalMaximum.amount) || totalBills, (globalMaximum === null || globalMaximum === void 0 ? void 0 : globalMaximum.currency_code) || ((_bills$billNames$ = bills[billNames[0]]) === null || _bills$billNames$ === void 0 ? void 0 : (_bills$billNames$$max = _bills$billNames$.maximum) === null || _bills$billNames$$max === void 0 ? void 0 : (_bills$billNames$$max2 = _bills$billNames$$max.max) === null || _bills$billNames$$max2 === void 0 ? void 0 : _bills$billNames$$max2.currency_code) || 'EUR')))))), landlordPoliciesData.length > 0 && __jsx(Sections, null, __jsx("h3", null, t('Other fees')), __jsx(SectionItemList, null, landlordPoliciesData.map(function (item, index) {
    return __jsx(SectionItem, {
      key: index,
      title: item.title,
      description: item.description,
      value: item.value,
      banner: item.banner
    });
  }))));
};
var SectionItem = function SectionItem(_ref2) {
  var title = _ref2.title,
    description = _ref2.description,
    value = _ref2.value,
    banner = _ref2.banner;
  return __jsx(React.Fragment, null, __jsx(SectionItemWrapper, null, __jsx(Description, null, __jsx("h4", null, title)), __jsx(Value, null, value)), __jsx("p", null, description), banner);
};
export default ServicesExpensesMobile;